import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { PageSpinner } from 'shared-components/decorators/spinner';
import { BookingRequestPageContainer as SinglePageCheckout } from '../../checkout/BookingRequestPage/BookingRequestPageContainer';
import { useStatsigContext } from '../../elements-statsig-provider/utils';
import BookingRequestContainer from './BookingRequest';

const BookingRequestExperiment = ({
  accessToken,
  params,
  location,
  profile,
  router,
  ...props
}) => {
  const searchParams = new URLSearchParams(location.search);

  const { initialized: statsigInitialized, experiments } = useStatsigContext();

  const showSingPageCheckout = useMemo(() => {
    if (!statsigInitialized || !experiments?.single_page_checkout_2) {
      return false;
    }
    return experiments.single_page_checkout_2()?.use_single_page_checkout;
  }, [statsigInitialized, experiments]);

  if (!statsigInitialized) {
    return <PageSpinner additionalStyle="gray" />;
  }

  if (showSingPageCheckout) {
    return (
      <SinglePageCheckout
        accessToken={accessToken}
        routeParams={params}
        searchParams={searchParams}
        profile={profile}
        router={router}
      />
    );
  }

  return (
    <BookingRequestContainer
      accessToken={accessToken}
      params={params}
      location={location}
      profile={profile}
      router={router}
      {...props}
    />
  );
};

BookingRequestExperiment.propTypes = {
  accessToken: PropTypes.string,
  params: PropTypes.object,
  location: PropTypes.object,
  profile: PropTypes.object,
  router: PropTypes.object
};

const mapStateToProps = ({ profile }) => {
  return { profile: profile?.data };
};

export default connect(mapStateToProps)(BookingRequestExperiment);
